<section class="text-upload-container">
  <h2 mat-dialog-title class="dialog-title">
    <i class="fas fa-align-left title-icon"></i>
    <span>{{ data?.title || 'Add Text' }}</span>
  </h2>

  <mat-dialog-content>
    <form [formGroup]="textForm" class="text-form">
      <div
        *ngFor="let question of questions; trackBy: trackByKey"
        class="question-row"
      >
        <app-question [question]="question" [form]="textForm"></app-question>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-stroked-button class="cancel-btn" (click)="onCancel()">
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      class="save-btn"
      (click)="onSubmit()"
      [disabled]="isSaving || textForm.invalid"
    >
      <mat-spinner *ngIf="isSaving" diameter="18" class="btn-spinner"></mat-spinner>
      <span>{{ isSaving ? 'Saving...' : 'Save Text' }}</span>
    </button>
  </mat-dialog-actions>
</section>
